import { FC, Fragment, PropsWithChildren } from 'react';

import { beastStatusAtom, instantReplayActiveSwingIdAtom, liveFeedbackActiveAtom } from '@realtime';
import { useAtomValue } from 'jotai';

import { currentActivityIdAtom, userSettingsAtom } from '@store';
import { Box } from '@ui';

import { LayoutModuleList } from '../components/LayoutModuleList/LayoutModuleList';
import { Sidebar } from '../components/Sidebar';
import { TopBar } from '../components/TopBar';
import { LiveAnalysisView } from '../components/VideoReplay/LiveAnalysisView';
import { LiveVideoView } from '../components/VideoReplay/LiveVideoView';
import { VideoReplay } from '../components/VideoReplay/VideoReplayView';
import { uiBeastStatusAtom } from '../store/status';

import * as css from './FloorScreen.css';

const FloorLayout: FC<PropsWithChildren> = ({ children }) => {
    const beastStatus = useAtomValue(uiBeastStatusAtom);
    return (
        <Box isolate className={css.root({ status: beastStatus })}>
            <TopBar />
            <div className={css.floorLayout}>
                <Sidebar />
                <div className={css.floorModulesWrapper}>{children}</div>
            </div>
        </Box>
    );
};

const FloorLiveView: FC = () => {
    const beastStatus = useAtomValue(beastStatusAtom);
    const activityId = useAtomValue(currentActivityIdAtom);
    const userSettings = useAtomValue(userSettingsAtom);

    const hasActivity = activityId !== -1;

    const activeSwingId = useAtomValue(instantReplayActiveSwingIdAtom);

    if (activeSwingId) return <VideoReplay />;

    if (beastStatus === 'BALL_STEADY' && userSettings.liveView && hasActivity) return <LiveVideoView />;

    return null;
};

const FloorLiveAnalysis: FC = () => {
    const liveAnalysisEnabled = useAtomValue(liveFeedbackActiveAtom);
    if (liveAnalysisEnabled) return <LiveAnalysisView />;
    return null;
};

export function FloorScreen() {
    return (
        <Fragment key="floor-screen">
            <FloorLiveView />
            <FloorLiveAnalysis />
            <FloorLayout>
                <LayoutModuleList />
            </FloorLayout>
        </Fragment>
    );
}
